import React from "react";

const TermsndServices = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6 md:px-20 text-gray-800">
      <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-8 md:p-12">
        <h1 className="text-3xl font-bold text-center text-indigo-700 mb-6">
          Terms & Conditions
        </h1>
        <p className="text-center text-sm text-gray-500 mb-10">
          <span className="italic">Last Updated: 2025</span>
        </p>

        {/* 1. Agreement to Terms */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            1. Agreement to Terms
          </h2>
          <p className="leading-relaxed">
            By accessing and using the <strong>Sridanth</strong> website and
            purchasing our products, you agree to be bound by these Terms of
            Service.
          </p>
        </section>

        {/* 2. Products */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            2. Products
          </h2>
          <p className="leading-relaxed mb-2">
            We make every effort to display our products as accurately as
            possible. However, actual colors and packaging may vary slightly.
            All products are subject to availability. We reserve the right to
            limit quantities and discontinue products at any time.
          </p>
        </section>

        {/* 3. Purchases and Payment */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            3. Purchases and Payment
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>You agree to provide current, complete, and accurate purchase information.</li>
            <li>
              We use third-party payment processors (e.g., Razorpay). Your
              payment is subject to their terms and conditions.
            </li>
            <li>Prices are in Indian Rupees (INR) and are subject to change.</li>
          </ul>
        </section>

        {/* 4. Shipping */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">4. Shipping</h2>
          <p className="leading-relaxed">
            Please see our Shipping Policy for delivery times and charges. You
            are responsible for providing the correct shipping address. We are
            not liable for delays caused by shipping carriers or circumstances
            beyond our control.
          </p>
        </section>

        {/* 5. Intellectual Property */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            5. Intellectual Property
          </h2>
          <p className="leading-relaxed">
            All content on this website (logos, text, images) is the property of{" "}
            <strong>Sri Sai Dental Aesthetics (Sridanth™)</strong> and is
            protected by copyright laws.
          </p>
        </section>

        {/* 6. Account Registration */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            6. Account Registration
          </h2>
          <p className="leading-relaxed">
            You may need to create an account to place an order. You are
            responsible for maintaining the confidentiality of your account and
            password.
          </p>
        </section>

        {/* 7. Limitation of Liability */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            7. Limitation of Liability
          </h2>
          <p className="leading-relaxed">
            <strong>Sri Sai Dental Aesthetics</strong> shall not be liable for
            any indirect, incidental, or consequential damages arising from the
            use of our products or website. Our total liability for any claim
            shall not exceed the cost of the products purchased by you.
          </p>
        </section>

        {/* 8. Governing Law */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            8. Governing Law
          </h2>
          <p className="leading-relaxed">
            These Terms shall be governed by and construed in accordance with
            the laws of India, and any disputes will be subject to the exclusive
            jurisdiction of the courts in <strong>Vijayawada, AP</strong>.
          </p>
        </section>

        {/* 9. Changes to Terms */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            9. Changes to Terms
          </h2>
          <p className="leading-relaxed">
            We may update these terms at any time. Continued use of the site
            after changes constitutes acceptance of the new terms.
          </p>
        </section>

        {/* 10. Contact Information */}
        <section>
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            10. Contact Information
          </h2>
          <p className="leading-relaxed">
            For questions about these Terms, please contact us at:{" "}
            <a
              href="mailto:support@sridanth.com"
              className="text-indigo-600 underline"
            >
              support@sridanth.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsndServices;
